module.exports = __webpack_public_path__ + "static/img/banner01.5e5708c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner01.png
// module id = vh2T
// module chunks = 1